export default "__VITE_ASSET__DYawINGQ__"